import { environment } from 'environments/environment';

/* eslint-disable @typescript-eslint/naming-convention */
export class ApiRouteConstants {
  // API Version
  public static API_BASE_PATH = `${environment.apiUrl}/internal-api/v1`;

  private static PAGE_SIZE = 20;

  // AUTHENTICATION
  public static AUTHENTICATION = {
    LOGIN: `${this.API_BASE_PATH}/auth/login`,
    LOGIN_CHECK: `${this.API_BASE_PATH}/auth/partner/login-check`,
    OTP_CHECK: `${this.API_BASE_PATH}/auth/partner/otp-check`,
    RE_AUTHENTICATE: `${this.API_BASE_PATH}/auth/re-authenticate`,
  };

  // PARTNER GROUP
  public static PARTNERGROUP = {
    CREATE: `${this.API_BASE_PATH}/partner-group`,
    GETALL: `${this.API_BASE_PATH}/partner-group`,
    UPDATE: `${this.API_BASE_PATH}/partner-group/partner-group-id/PARTNERGROUPID`,
    GETBYID: `${this.API_BASE_PATH}/partner-group/partner-group-id/PARTNERGROUPID`,
  };

  // PARTNER
  public static PARTNER = {
    CREATE: `${this.API_BASE_PATH}/partner`,
    GETALL: `${this.API_BASE_PATH}/partner`,
    UPDATE: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID`,
    GETBYID: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID`,
    STAFF_LIST: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff`,
    STAFF_ALLOWED_PERMISSIONS: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/allowed-permissions`,
    STAFF_CREATE: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff`,
    STAFF_UPDATE: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff/STAFFID`,
    STAFF_DELETE: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff/STAFFID`,
    STAFF_ASSIGN_PERMISSIONS: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff/STAFFID/permissions`,
    STAFF_RESEND_INVITE: `${this.API_BASE_PATH}/partner/partner-id/PARTNERID/staff/STAFFID/resend-invite`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/partner/dashboard-data`,
    CHANGEPASSWORD: `${this.API_BASE_PATH}/partner/change-password/partner-id/PARTNERID`,
    CHANGEPASSWORD_SELF: `${this.API_BASE_PATH}/partner/change-password/self`,
    FORGOTPASSWORD: `${this.API_BASE_PATH}/partner/forgot-password`,
    FORGOTPASSWORDOTPCHECK: `${this.API_BASE_PATH}/partner/forgot-password-partner-otp-check`,
    FORGOTPASSWORD_STAFF: `${this.API_BASE_PATH}/partner/forgot-password-staff`,
    FORGOTPASSWORD_STAFF_OTPCHECK: `${this.API_BASE_PATH}/partner/forgot-password-staff-otp-check`,
    RESETPASSWORD: `${this.API_BASE_PATH}/partner/reset-password/partner-id/PARTNERID`,
    RESETPASSWORD_STAFF: `${this.API_BASE_PATH}/partner/reset-password-staff/partner-id/PARTNERID/staff-id/STAFFID`,
    SETPASSWORD_STAFF: `${this.API_BASE_PATH}/partner/set-password-staff/partner-id/PARTNERID/staff-id/STAFFID`,
    GETBYSUBCRIPTIONID: `${this.API_BASE_PATH}/partner/subcription-id/SUBCRIPTIONID`,
    PRODUCERDELETE: `${this.API_BASE_PATH}/partner/delete-producer-account/partner-id/PARTNERID`,
    UPLOAD: `${this.API_BASE_PATH}/partner/upload`,
  };
  // PRODUCT
  public static PRODUCT = {
    CREATE: `${this.API_BASE_PATH}/product`,
    GETALL: `${this.API_BASE_PATH}/product`,
    UPDATE: `${this.API_BASE_PATH}/product/product-id/PRODUCTID`,
    GETBYID: `${this.API_BASE_PATH}/product/product-id/PRODUCTID`,
    CREATEBULKPRODUCT: `${this.API_BASE_PATH}/product/create-multiple`,
    GETBYPRODUCERID: `${this.API_BASE_PATH}/product/producer-id/PRODUCERID`,
    GETBYBRAND: `${this.API_BASE_PATH}/product/brand/BRAND`,
    GETBYBARCODE: `${this.API_BASE_PATH}/product/barcode/BARCODE`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/product/dashboard-data/partner-id/PARTNERID`,
    UPLOAD: `${this.API_BASE_PATH}/product/upload`,
  };

  // AUDITLOG
  public static AUDITLOG = {
    GETALL: `${this.API_BASE_PATH}/audit-log`,
  };

  // OFFER
  public static OFFER = {
    CREATE: `${this.API_BASE_PATH}/offer`,
    GETALL: `${this.API_BASE_PATH}/offer`,
    UPDATE: `${this.API_BASE_PATH}/offer/offer-id/OFFERID`,
    GETBYID: `${this.API_BASE_PATH}/offer/offer-id/OFFERID`,
    GETBYPRODUCERID: `${this.API_BASE_PATH}/offer/producer-id/PRODUCERID`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/offer/dashboard-data`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/offer/dashboard-data/partner-id/PARTNERID`,
    UPLOAD: `${this.API_BASE_PATH}/offer/upload`,
  };

  // NEWS
  public static NEWS = {
    CREATE: `${this.API_BASE_PATH}/news`,
    GETALL: `${this.API_BASE_PATH}/news`,
    UPDATE: `${this.API_BASE_PATH}/news/news-id/NEWSID`,
    GETBYID: `${this.API_BASE_PATH}/news/news-id/NEWSID`,
    GETBYCREATEDBY: `${this.API_BASE_PATH}/news/created-by/CREATEDBY`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/news/dashboard-data`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/news/dashboard-data/partner-id/PARTNERID`,
    UPLOADIMAGE: `${this.API_BASE_PATH}/news/upload-image`,
    GETREWARDPRODUCTLIST: `${this.API_BASE_PATH}/news/product-list/producer-id/PRODUCERID`,
    GETBYBRAND: `${this.API_BASE_PATH}/news/brand/BRANDID`,
    UPLOAD: `${this.API_BASE_PATH}/news/upload-video`,
  };

  // BANNER
  public static BANNER = {
    CREATE: `${this.API_BASE_PATH}/banner`,
    GETALL: `${this.API_BASE_PATH}/banner`,
    UPDATE: `${this.API_BASE_PATH}/banner/banner-id/BANNERID`,
    GETBYID: `${this.API_BASE_PATH}/banner/banner-id/BANNERID`,
    GETBANNERBYCREATEDBY: `${this.API_BASE_PATH}/banner/created-by/CREATEDBY`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/banner/dashboard-data`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/banner/dashboard-data/partner-id/CREATEDBY`,
    GETBYBRAND: `${this.API_BASE_PATH}/banner/brand/BRANDID`,
    UPLOAD: `${this.API_BASE_PATH}/banner/upload`,
  };

  // AD CLICKS
  public static BANNERCLICKS = {
    CREATE: `${this.API_BASE_PATH}/banner-clicks`,
    GETALL: `${this.API_BASE_PATH}/banner-clicks`,
    UPDATE: `${this.API_BASE_PATH}/banner-clicks/banner-clicks-id/BANNERCLICKSID`,
    GETBYID: `${this.API_BASE_PATH}/banner-clicks/abannerd-clicks-id/BANNERCLICKSID`,
    GETBYBANNERID: `${this.API_BASE_PATH}/banner-clicks/banner-id/BANNERID`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/banner-clicks/dashboard-data/user-id/USERID`,
  };

  // RECEIPT
  public static RECEIPT = {
    CREATE: `${this.API_BASE_PATH}/receipt`,
    GETALL: `${this.API_BASE_PATH}/receipt`,
    UPDATE: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID`,
    GETBYID: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID`,
    UPDATEOPENAIRESPONSEPRODUCTS: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID/open-ai-response/products`,
    UPLOADIMAGES: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID/upload/receipt`,
    GETRECEIPTBYUSERID: `${this.API_BASE_PATH}/receipt/user-id/USERID`,
    GETVALIDRATEBYPRODUCTID: `${this.API_BASE_PATH}/receipt/valid-rate/product-id/PRODUCTID`,
    UPDATEBALANCEBYUSERID: `${this.API_BASE_PATH}/receipt/update-balance/user-id/USERID/receipt-id/RECEIPTID`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/receipt/dashboard-data`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/receipt/dashboard-data/user-id/USERID`,
    UPDATEBALANCERECEIPTPRODUCTMAPPING: `${this.API_BASE_PATH}/receipt/update-receipt-product-mapping/user-id/USERID/receipt-id/RECEIPTID`,
    DELETERECEIPTPRODUCTMAPPING: `${this.API_BASE_PATH}/receipt/delete-receipt-product-mapping`,
    SCANRECEIPTBYID: `${this.API_BASE_PATH}/receipt/scan-receipt-by-id/RECEIPTID`,
    REPROCESSOPENAIRESPONSE: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID/reprocess-open-ai-response`,
    REPROCESSGOOGLEVISIONOPENAI: `${this.API_BASE_PATH}/receipt/receipt-id/RECEIPTID/reprocess-receipt-in-google-vision-api-open-ai`,
  };

  // ROLE
  public static ROLE = {
    CREATE: `${this.API_BASE_PATH}/role`,
    GETALL: `${this.API_BASE_PATH}/role`,
    UPDATE: `${this.API_BASE_PATH}/role/role-id/ROLEID`,
    GETBYID: `${this.API_BASE_PATH}/role/role-id/ROLEID`,
  };

  // RATE
  public static RATE = {
    CREATE: `${this.API_BASE_PATH}/rate`,
    GETALL: `${this.API_BASE_PATH}/rate`,
    UPDATE: `${this.API_BASE_PATH}/rate/rate-id/RATEID`,
    GETBYID: `${this.API_BASE_PATH}/rate/rate-id/RATEID`,
    GETBYOFFERID: `${this.API_BASE_PATH}/rate/offer-id/OFFERID`,
  };

  // PRODUCR OFFER LINK
  public static PRODUCTOFFERLINK = {
    CREATE: `${this.API_BASE_PATH}/product-offer-link`,
    GETALL: `${this.API_BASE_PATH}/product-offer-link`,
    UPDATE: `${this.API_BASE_PATH}/product-offer-link/product-offer-link-id/PRODUCTOFFERLINKID`,
    GETBYID: `${this.API_BASE_PATH}/product-offer-link/product-offer-link-id/PRODUCTOFFERLINKID`,
    GETBYOFFERID: `${this.API_BASE_PATH}/product-offer-link/offer-id/OFFERID`,
    GETBYPRODUCTID: `${this.API_BASE_PATH}/product-offer-link/product-id/PRODUCTID`,
  };

  // REWARD TIER
  public static REWARDTIER = {
    CREATE: `${this.API_BASE_PATH}/reward-tier`,
    GETALL: `${this.API_BASE_PATH}/reward-tier`,
    UPDATE: `${this.API_BASE_PATH}/reward-tier/reward-tier-id/REWARDTIERID`,
    GETBYID: `${this.API_BASE_PATH}/reward-tier/reward-tier-id/REWARDTIERID`,
    GETBYOFFERID: `${this.API_BASE_PATH}/reward-tier/reward/offer-id/OFFERID`,
  };

  // REWARD
  public static REWARD = {
    CREATE: `${this.API_BASE_PATH}/reward`,
    GETALL: `${this.API_BASE_PATH}/reward`,
    UPDATE: `${this.API_BASE_PATH}/reward/reward-id/REWARDID`,
    GETBYID: `${this.API_BASE_PATH}/reward/reward-id/REWARDID`,
    GETBYOFFERID: `${this.API_BASE_PATH}/reward/offer-id/OFFERID`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/reward/dashboard-data`,
    GETBYBRAND: `${this.API_BASE_PATH}/reward/brand/BRAND`,
    GETVALIDREWARDBYPRODUCERID: `${this.API_BASE_PATH}/reward/valid-reward/producer-id/PRODUCERID`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/reward/dashboard-data/partner-id/PARTNERID`,
    GETREWARDBYOFFERIDBARCODE: `${this.API_BASE_PATH}/reward/offer-id/OFFERID/bar-code/BARCODE`,
    UPDATEREWARDAVAILABLEBRANCHIDS: `${this.API_BASE_PATH}/reward/update-reward-available-branch-ids/offer-id/OFFERID`,
    GETIMPORTREWARDSEXCELTEMPLATE: `${this.API_BASE_PATH}/reward/import-excel/template`,
    IMPORTREWARDSFROMEXCEL: `${this.API_BASE_PATH}/reward/import-excel`,
  };

  // VOUCHER
  public static VOUCHER = {
    CREATE: `${this.API_BASE_PATH}/voucher`,
    GETALL: `${this.API_BASE_PATH}/voucher`,
    UPDATE: `${this.API_BASE_PATH}/voucher/voucher-id/VOUCHERID`,
    GETBYID: `${this.API_BASE_PATH}/voucher/voucher-id/VOUCHERID`,
    GETBYOFFERID: `${this.API_BASE_PATH}/voucher/offer-id/OFFERID`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/voucher/dashboard-data/partner-id/PARTNERID`,
    CREATEVOUCHERUSINGEXCELUPLOAD: `${this.API_BASE_PATH}/voucher/create-voucher-using-excel-upload`,
    CREATEVOUCHER: `${this.API_BASE_PATH}/voucher/create-voucher`,
    UPDATEVOUCHER: `${this.API_BASE_PATH}/voucher/update-voucher/voucher-id/VOUCHERID`,
  };

  // USER - CONSUMER
  public static USER = {
    CREATE: `${this.API_BASE_PATH}/user`,
    GETALL: `${this.API_BASE_PATH}/user`,
    UPDATE: `${this.API_BASE_PATH}/user/user-id/USERID`,
    GETBYID: `${this.API_BASE_PATH}/user/user-id/USERID`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/user/dashboard-data`,
  };

  // USER REWARD
  public static USERREWARD = {
    CREATE: `${this.API_BASE_PATH}/user-reward`,
    GETALL: `${this.API_BASE_PATH}/user-reward`,
    GETALLREDEEMED: `${this.API_BASE_PATH}/user-reward?is_redeem=true&rewardKind=product`,
    UPDATE: `${this.API_BASE_PATH}/user-reward/user-reward-id/USERREWARDID`,
    GETBYID: `${this.API_BASE_PATH}/user-reward/user-reward-id/USERREWARDID`,
    GETUSERREWARDBYUSERID: `${this.API_BASE_PATH}/user-reward/user-id/USERID`,
    GETREDEEMEDUSERREWARDBYPARTNERID: `${this.API_BASE_PATH}/user-reward/partner-id/PARTNERID?is_redeem=true&rewardKind=product`,
    GETMONEYREWARDSBYOFFER: `${this.API_BASE_PATH}/user-reward/money-rewards-by-offer`,
    GETMONEYREWARDSBYOFFERID: `${this.API_BASE_PATH}/user-reward/money-rewards-by-offer/offer-id/OFFERID`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/user-reward/dashboard-data/user-id/USERID`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/user-reward/dashboard-data/partner-id/PARTNERID`,
  };

  // USER VOUCHER
  public static USERVOUCHER = {
    CREATE: `${this.API_BASE_PATH}/user-voucher`,
    GETALL: `${this.API_BASE_PATH}/user-voucher`,
    UPDATE: `${this.API_BASE_PATH}/user-voucher/user-voucher-id/USERVOUCHERID`,
    GETBYID: `${this.API_BASE_PATH}/user-voucher/user-voucher-id/USERVOUCHERID`,
    GETUSERVOUCHERBYUSERID: `${this.API_BASE_PATH}/user-voucher/user/user-id/USERID`,
    GETDASHBOARDDATA: `${this.API_BASE_PATH}/user-voucher/dashboard-data`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/user-voucher/dashboard-data/user-id/USERID`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/user-voucher/dashboard-data/partner-id/PARTNERID`,
  };

  // RECEIPT PRODUCT MAPPING
  public static RECEIPTPRODUCTMAPPING = {
    CREATE: `${this.API_BASE_PATH}/receipt-product-mapping`,
    GETALL: `${this.API_BASE_PATH}/receipt-product-mapping`,
    UPDATE: `${this.API_BASE_PATH}/receipt-product-mapping/receipt-product-mapping-id/RECEIPTPRODUCTMAPPINGID`,
    GETBYID: `${this.API_BASE_PATH}/receipt-product-mapping/receipt-product-mapping-id/RECEIPTPRODUCTMAPPINGID`,
    CREATEBULKRECEIPTPRODUCTMAPPING: `${this.API_BASE_PATH}/receipt-product-mapping/create-multiple`,
    GETBYRECEIPTID: `${this.API_BASE_PATH}/receipt-product-mapping/receipt-id/RECEIPTID`,
    UPDATEBULKRECEIPTPRODUCTMAPPING: `${this.API_BASE_PATH}/receipt-product-mapping/update-multiple`,
  };

  // USER OFFER BALANCE
  public static USEROFFERBALANCE = {
    CREATE: `${this.API_BASE_PATH}/user-offer-balance`,
    GETALL: `${this.API_BASE_PATH}/user-offer-balance`,
    UPDATE: `${this.API_BASE_PATH}/user-offer-balance/user-offer-balance-id/USEROFFERBALANCEID`,
    GETBYID: `${this.API_BASE_PATH}/user-offer-balance/user-offer-balance-id/USEROFFERBALANCEID`,
    GETUSEROFFERBALANCEBYUSERID: `${this.API_BASE_PATH}/user-offer-balance/user-id/USERID`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/user-offer-balance/dashboard-data/user-id/USERID`,
    ADJUSTCOUNTERS: `${this.API_BASE_PATH}/user-offer-balance/adjust-counters`,
    ADDPOINTS: `${this.API_BASE_PATH}/user-offer-balance/add-points`,
  };

  // FAMILY OFFER BALANCE
  public static FAMILYOFFERBALANCE = {
    GETALL: `${this.API_BASE_PATH}/family-offer-balance`,
  };

  // USER OFFER CYCLE BALANCE
  public static USEROFFERCYCLEBALANCE = {
    CREATE: `${this.API_BASE_PATH}/user-offer-cycle-balance`,
    GETALL: `${this.API_BASE_PATH}/user-offer-cycle-balance`,
    UPDATE: `${this.API_BASE_PATH}/user-offer-cycle-balance/user-offer-cycle-balance-id/USEROFFERCYCLEBALANCEID`,
    GETBYID: `${this.API_BASE_PATH}/user-offer-cycle-balance/user-offer-cycle-balance-id/USEROFFERCYCLEBALANCEID`,
    GETUSEROFFERCYCLEBALANCEBYUSERID: `${this.API_BASE_PATH}/user-offer-cycle-balance/user-id/USERID`,
  };

  // CATEGORY
  public static CATEGORY = {
    CREATE: `${this.API_BASE_PATH}/category`,
    GETALL: `${this.API_BASE_PATH}/category`,
    UPDATE: `${this.API_BASE_PATH}/category/category-id/CATEGORYID`,
    GETBYID: `${this.API_BASE_PATH}/category/category-id/CATEGORYID`,
    CREATEBULKCATEGORY: `${this.API_BASE_PATH}/category/create-multiple`,
  };

  // SUBCATEGORY1
  public static SUBCATEGORY1 = {
    CREATE: `${this.API_BASE_PATH}/subcategory1`,
    GETALL: `${this.API_BASE_PATH}/subcategory1`,
    UPDATE: `${this.API_BASE_PATH}/subcategory1/subcategory1-id/SUBCATEGORY1ID`,
    GETBYID: `${this.API_BASE_PATH}/subcategory1/subcategory1-id/SUBCATEGORY1ID`,
    GETBYCATEGORYID: `${this.API_BASE_PATH}/subcategory1/category-id/CATEGORYID`,
    CREATEBULKSUBCATEGORY1: `${this.API_BASE_PATH}/subcategory1/create-multiple`,
  };

  // SUBCATEGORY2
  public static SUBCATEGORY2 = {
    CREATE: `${this.API_BASE_PATH}/subcategory2`,
    GETALL: `${this.API_BASE_PATH}/subcategory2`,
    UPDATE: `${this.API_BASE_PATH}/subcategory2/subcategory2-id/SUBCATEGORY2ID`,
    GETBYID: `${this.API_BASE_PATH}/subcategory2/subcategory2-id/SUBCATEGORY2ID`,
    GETBYSUBCATEGORY1ID: `${this.API_BASE_PATH}/subcategory2/subcategory1-id/SUBCATEGORY1ID`,
    CREATEBULKSUBCATEGORY2: `${this.API_BASE_PATH}/subcategory2/create-multiple`,
  };

  // SUBCATEGORY3
  public static SUBCATEGORY3 = {
    CREATE: `${this.API_BASE_PATH}/subcategory3`,
    GETALL: `${this.API_BASE_PATH}/subcategory3`,
    UPDATE: `${this.API_BASE_PATH}/subcategory3/subcategory3-id/SUBCATEGORY3ID`,
    GETBYID: `${this.API_BASE_PATH}/subcategory3/subcategory3-id/SUBCATEGORY3ID`,
    GETBYSUBCATEGORY2ID: `${this.API_BASE_PATH}/subcategory3/subcategory2-id/SUBCATEGORY2ID`,
    CREATEBULKSUBCATEGORY3: `${this.API_BASE_PATH}/subcategory3/create-multiple`,
  };

  // USER PARTNER LOYALTY
  public static USERPARTNERLOYALTY = {
    CREATE: `${this.API_BASE_PATH}/user-partner-loyalty`,
    GETALL: `${this.API_BASE_PATH}/user-partner-loyalty`,
    UPDATE: `${this.API_BASE_PATH}/user-partner-loyalty/user-partner-loyalty-id/USERPARTNERLOYALTYID`,
    GETBYID: `${this.API_BASE_PATH}/user-partner-loyalty/user-partner-loyalty-id/USERPARTNERLOYALTYID`,
    GETUSERPARTNERLOYALTYBYUSERID: `${this.API_BASE_PATH}/user-partner-loyalty/user-id/USERID`,
  };

  // SPIN QUESTION
  public static SPINQUESTION = {
    CREATE: `${this.API_BASE_PATH}/spin-question`,
    GETALL: `${this.API_BASE_PATH}/spin-question`,
    UPDATE: `${this.API_BASE_PATH}/spin-question/spin-question-id/SPINQUESTIONID`,
    GETBYID: `${this.API_BASE_PATH}/spin-question/spin-question-id/SPINQUESTIONID`,
    GETBYPRODUCERID: `${this.API_BASE_PATH}/spin-question/producer-id/PRODUCERID`,
  };

  // SPIN USER QUESTION HISTORY
  public static SPINUSERQUESTIONHISTORY = {
    CREATE: `${this.API_BASE_PATH}/spin-user-question-history`,
    GETALL: `${this.API_BASE_PATH}/spin-user-question-history`,
    UPDATE: `${this.API_BASE_PATH}/spin-user-question-history/spin-user-question-history-id/SPINUSERQUESTIONHISTORYID`,
    GETBYID: `${this.API_BASE_PATH}/spin-user-question-history/spin-user-question-history-id/SPINUSERQUESTIONHISTORYID`,
    GETBYQUESTIONID: `${this.API_BASE_PATH}/spin-user-question-history/question-id/QUESTIONID`,
  };

  // SPIN
  public static SPIN = {
    CREATE: `${this.API_BASE_PATH}/spin`,
    GETALL: `${this.API_BASE_PATH}/spin`,
    UPDATE: `${this.API_BASE_PATH}/spin/spin-id/SPINID`,
    GETBYID: `${this.API_BASE_PATH}/spin/spin-id/SPINID`,
    GETBYPRODUCTID: `${this.API_BASE_PATH}/spin/product-id/PRODUCTID`,
    GETBYBRAND: `${this.API_BASE_PATH}/spin/brand/BRANDID`,
    CREATEBULKSPIN: `${this.API_BASE_PATH}/spin/create-multiple`,
    UPDATEBULKSPIN: `${this.API_BASE_PATH}/spin/update-multiple`,
    GETSPINBYCREATEDBY: `${this.API_BASE_PATH}/spin/created-by/CREATEDBY`,
    GETBYQUESTIONID: `${this.API_BASE_PATH}/spin/question-id/QUESTIONID`,
    GETBYSPINREWARDID: `${this.API_BASE_PATH}/spin/spin-reward-id/SPINREWARDID`,
  };

  // SPIN REWARD
  public static SPINREWARD = {
    CREATE: `${this.API_BASE_PATH}/spin-reward`,
    GETALL: `${this.API_BASE_PATH}/spin-reward`,
    UPDATE: `${this.API_BASE_PATH}/spin-reward/spin-reward-id/SPINREWARDID`,
    GETBYID: `${this.API_BASE_PATH}/spin-reward/spin-reward-id/SPINREWARDID`,
    GETBYPRODUCERID: `${this.API_BASE_PATH}/spin-reward/producer-id/PRODUCERID`,
  };

  // SPIN RESULT
  public static SPINRESULT = {
    CREATE: `${this.API_BASE_PATH}/spin-result`,
    GETALL: `${this.API_BASE_PATH}/spin-result`,
    UPDATE: `${this.API_BASE_PATH}/spin-result/spin-result-id/SPINRESULTID`,
    GETBYID: `${this.API_BASE_PATH}/spin-result/spin-result-id/SPINRESULTID`,
    GETBYREWARDID: `${this.API_BASE_PATH}/spin-result/spin-reward-id/SPINREWARDID`,
    GETBYUSERID: `${this.API_BASE_PATH}/spin-result/user-id/USERID`,
    GETUSERDASHBOARDDATA: `${this.API_BASE_PATH}/spin-result/dashboard-data/user-id/USERID`,
    GETPARTNERDASHBOARDDATA: `${this.API_BASE_PATH}/spin-result/dashboard-data/partner-id/PARTNERID`,
  };

  // SUBSCRIPTION
  public static SUBSCRIPTION = {
    CREATE: `${this.API_BASE_PATH}/subscription`,
    GETALL: `${this.API_BASE_PATH}/subscription`,
    UPDATE: `${this.API_BASE_PATH}/subscription/subscription-id/SUBSCRIPTIONID`,
    GETBYID: `${this.API_BASE_PATH}/subscription/subscription-id/SUBSCRIPTIONID`,
  };

  // USER BALANCE
  public static USERBALANCE = {
    CREATE: `${this.API_BASE_PATH}/user-balance`,
    GETALL: `${this.API_BASE_PATH}/user-balance`,
    UPDATE: `${this.API_BASE_PATH}/user-balance/user-balance-id/USERBALANCEID`,
    GETBYID: `${this.API_BASE_PATH}/user-balance/user-balance-id/USERBALANCEID`,
    GETBYUSERID: `${this.API_BASE_PATH}/user-balance/user-id/USERID`,
  };

  // WALLET
  public static WALLET = {
    GETBYUSERID: `${this.API_BASE_PATH}/wallet/user-id/USERID`,
  };

  // CHAT CONVERSATION
  public static CHATCONVERSATION = {
    CREATE: `${this.API_BASE_PATH}/chat-conversation`,
    GETALL: `${this.API_BASE_PATH}/chat-conversation`,
    UPDATE: `${this.API_BASE_PATH}/chat-conversation/chat-conversation-id/CHATCONVERSATIONID`,
    GETBYID: `${this.API_BASE_PATH}/chat-conversation/chat-conversation-id/CHATCONVERSATIONID`,
    GETBYUSERID: `${this.API_BASE_PATH}/chat-conversation/user-id/USERID`,
    GETBYPARTNERID: `${this.API_BASE_PATH}/chat/conversation/partner-id/PARTNERID`,
    GETBYLASTMESSAGE: `${this.API_BASE_PATH}/chat-conversation/last-message-id/LASTMESSAGEID`,
    READMESSAGES: `${this.API_BASE_PATH}/chat/read-messages/conversation-id/CONVERSATIONID/user-id/USERID`,
  };

  // CHAT MESSAGE
  public static CHATMESSAGE = {
    CREATE: `${this.API_BASE_PATH}/chat-message`,
    GETALL: `${this.API_BASE_PATH}/chat-message`,
    UPDATE: `${this.API_BASE_PATH}/chat-message/chat-message-id/CHATMESSAGEID`,
    GETBYID: `${this.API_BASE_PATH}/chat-message/chat-message-id/CHATMESSAGEID`,
    GETBYCONVERSATIONID: `${this.API_BASE_PATH}/chat/messages/conversation-id/CONVERSATIONID?pageSize=${this.PAGE_SIZE}`,
    GETBYSENDERID: `${this.API_BASE_PATH}/chat-message/sender-id/SENDERID?pageSize=${this.PAGE_SIZE}`,
    CREATECHATMESSAGEANDUPDATECHATCONVERSATION: `${this.API_BASE_PATH}/chat/update-chat-conversation`,
    UPLOADIMAGE: `${this.API_BASE_PATH}/chat/upload-image`,
  };

  // REPORTED CHAT
  public static REPORTEDCHAT = {
    CREATE: `${this.API_BASE_PATH}/reported-chat`,
    GETALL: `${this.API_BASE_PATH}/reported-chat`,
    UPDATE: `${this.API_BASE_PATH}/reported-chat/reported-chat-id/REPORTEDCHATID`,
    GETBYID: `${this.API_BASE_PATH}/reported-chat/reported-chat-id/REPORTEDCHATID`,
    GETBYCONVERSATIONID: `${this.API_BASE_PATH}/reported-chat/conversation-id/CONVERSATIONID`,
    GETBYUSERID: `${this.API_BASE_PATH}/reported-chat/user-id/USERID`,
  };

  // PRODUCT CATALOGUE
  public static SKUCATALOGUE = {
    CREATE: `${this.API_BASE_PATH}/sku-catalogue`,
    GETALL: `${this.API_BASE_PATH}/sku-catalogue`,
    UPDATE: `${this.API_BASE_PATH}/sku-catalogue/sku-catalogue-id/SKUCATALOGUEID`,
    GETBYID: `${this.API_BASE_PATH}/sku-catalogue/sku-catalogue-id/SKUCATALOGUEID`,
    GETBYBRANDID: `${this.API_BASE_PATH}/sku-catalogue/brand-id/BRANDID`,
    GETBYCATEGORYID: `${this.API_BASE_PATH}/sku-catalogue/category-id/CATEGORYID`,
    GETBYSUBCATEGORY1ID: `${this.API_BASE_PATH}/sku-catalogue/subcategory1-id/SUBCATEGORY1ID`,
    GETBYSTOREID: `${this.API_BASE_PATH}/sku-catalogue/store-id/STOREID`,
    CREATEBULKPRODUCTCATALOGUE: `${this.API_BASE_PATH}/sku-catalogue/create-multiple-product-catalogue`,
    GETBYBARCODE: `${this.API_BASE_PATH}/sku-catalogue/bar-code/BARCODE`,
  };

  // BRAND
  public static BRAND = {
    CREATE: `${this.API_BASE_PATH}/brand`,
    GETALL: `${this.API_BASE_PATH}/brand`,
    UPDATE: `${this.API_BASE_PATH}/brand/brand-id/BRANDID`,
    GETBYID: `${this.API_BASE_PATH}/brand/brand-id/BRANDID`,
    GETBYPARTNERID: `${this.API_BASE_PATH}/brand/partner-id/PARTNERID`,
    UPLOAD: `${this.API_BASE_PATH}/brand/upload`,
  };

  //Targeted Marketing
  public static TARGETEDMARKETING = {
    CREATE: `${this.API_BASE_PATH}/targeted-marketing`,
    GETALL: `${this.API_BASE_PATH}/targeted-marketing`,
    UPDATE: `${this.API_BASE_PATH}/targeted-marketing/targeted-marketing-id/TARGETEDMARKETINGID`,
    GETBYID: `${this.API_BASE_PATH}/targeted-marketing/targeted-marketing-id/TARGETEDMARKETINGID`,
    GETBYWEEKANDYEAR: `${this.API_BASE_PATH}/targeted-marketing/week-number/WEEKNUMBER/year/YEAR`,
    PROCESSTARGETEDMARKETING: `${this.API_BASE_PATH}/targeted-marketing/process-tarket-marketing`,
    CLEARTARGETMARKETINGLOCK: `${this.API_BASE_PATH}/targeted-marketing/clear-target-marketing-lock`,
  };

  //TM User Banner
  public static TMUSERBANNER = {
    CREATE: `${this.API_BASE_PATH}/tm-user-banner`,
    GETALL: `${this.API_BASE_PATH}/tm-user-banner`,
    UPDATE: `${this.API_BASE_PATH}/tm-user-banner/tm-user-banner-id/TMUSERBANNERID`,
    UPDATEBYTMID: `${this.API_BASE_PATH}/tm-user-banner/tm-targeted-marketing-id/TMID`,
    GETBYID: `${this.API_BASE_PATH}/tm-user-banner/tm-user-banner-id/TMUSERBANNERID`,
    GETBYWEEKANDYEAR: `${this.API_BASE_PATH}/tm-user-banner/user-id/USERID/week-number/WEEKNUMBER/year/YEAR`,
  };

  //TM User NEWS
  public static TMUSERNEWS = {
    CREATE: `${this.API_BASE_PATH}/tm-user-news`,
    GETALL: `${this.API_BASE_PATH}/tm-user-news`,
    UPDATE: `${this.API_BASE_PATH}/tm-user-news/tm-user-news-id/TMUSERNEWSID`,
    UPDATEBYTMID: `${this.API_BASE_PATH}/tm-user-news/tm-targeted-marketing-id/TMID`,
    GETBYID: `${this.API_BASE_PATH}/tm-user-news/tm-user-news-id/TMUSERNEWSID`,
    GETBYWEEKANDYEAR: `${this.API_BASE_PATH}/tm-user-news/user-id/USERID/week-number/WEEKNUMBER/year/YEAR`,
  };

  //TM User NEWS
  public static TMUSERSPIN = {
    CREATE: `${this.API_BASE_PATH}/tm-user-spin`,
    GETALL: `${this.API_BASE_PATH}/tm-user-spin`,
    UPDATE: `${this.API_BASE_PATH}/tm-user-spin/tm-user-spin-id/TMUSERSPINID`,
    UPDATEBYTMID: `${this.API_BASE_PATH}/tm-user-spin/tm-targeted-marketing-id/TMID`,
    GETBYID: `${this.API_BASE_PATH}/tm-user-spin/tm-user-spin-id/TMUSERSPINID`,
    GETBYWEEKANDYEAR: `${this.API_BASE_PATH}/tm-user-spin/user-id/USERID/week-number/WEEKNUMBER/year/YEAR`,
  };

  //OPENAI PROMPT
  public static OPENAIPROMPT = {
    GETALL: `${this.API_BASE_PATH}/openai-prompt`,
    UPDATE: `${this.API_BASE_PATH}/openai-prompt/openai-prompt-id/OPENAIPROMPTID`,
    UPLOADFILESINTOOPENAI: `${this.API_BASE_PATH}/openai-prompt/upload-files-into-openai`,
  };

  //HOBBY INTEREST CATEGORY
  public static HOBBYINTERESTCATEGORY = {
    CREATE: `${this.API_BASE_PATH}/hobby-interest-category`,
    GETALL: `${this.API_BASE_PATH}/hobby-interest-category`,
    UPDATE: `${this.API_BASE_PATH}/hobby-interest-category/hobby-interest-category-id/HOBBYINTERESTCATEGORYID`,
    GETBYID: `${this.API_BASE_PATH}/hobby-interest-category/hobby-interest-category-id/HOBBYINTERESTCATEGORYID`,
    CREATEBULKHOBBYINTERESTCATEGORY: `${this.API_BASE_PATH}/hobby-interest-category/create-multiple-hobby-interest-category`,
  };

  //HOBBY INTEREST ITEM
  public static HOBBYINTERESTITEM = {
    CREATE: `${this.API_BASE_PATH}/hobby-interest-item`,
    GETALL: `${this.API_BASE_PATH}/hobby-interest-item`,
    UPDATE: `${this.API_BASE_PATH}/hobby-interest-item/hobby-interest-item-id/HOBBYINTERESTITEMID`,
    GETBYID: `${this.API_BASE_PATH}/hobby-interest-item/hobby-interest-item-id/HOBBYINTERESTITEMID`,
    CREATEBULKHOBBYINTERESTITEM: `${this.API_BASE_PATH}/hobby-interest-item/create-multiple-hobby-interest-item`,
    GETBYHOBBYINTERESTCATEGORYID: `${this.API_BASE_PATH}/hobby-interest-item/hobby-interest-category-id/HOBBYINTERESTCATEGORYID`,
  };

  //USER INTEREST
  public static USERINTERES = {
    GETBYHOBBYINTERESTCATEGORYID: `${this.API_BASE_PATH}/user-interest/hobby-interest-category-id/HOBBYINTERESTCATEGORYID`,
    GETBYHOBBYINTERESTITEMID: `${this.API_BASE_PATH}/user-interest/hobby-interest-item-id/HOBBYINTERESTITEMID`,
  };
  public static DELIVERY = {
    CREATE: `${this.API_BASE_PATH}/shipment`,
    GETALL: `${this.API_BASE_PATH}/shipment`,
    UPDATE: `${this.API_BASE_PATH}/shipment/shipment-id/SHIPMENTID`,
    GETBYID: `${this.API_BASE_PATH}/shipment/shipment-id/SHIPMENTID`,
    GETREWARDSBYPARTNERID: `${this.API_BASE_PATH}/shipment/rewards/partner-id/PARTNERID`,
    UPDATEREWARDDELIVERYSTATUS: `${this.API_BASE_PATH}/shipment/rewards/status`,
    PROCESSDELIVERY: `${this.API_BASE_PATH}/shipment/shipment-id/SHIPMENTID/process-delivery`,
    BULKPROCESSDELIVERY: `${this.API_BASE_PATH}/shipment/bulk/process-delivery`,
    PROCESSNETGLOBALREWARDS: `${this.API_BASE_PATH}/shipment/net-global/process-delivery`,
    UPDATESTATUS: `${this.API_BASE_PATH}/shipment/shipment-id/SHIPMENTID/status`,
  };

  // DELIVERY METHOD
  public static DELIVERYMETHOD = {
    CREATE: `${this.API_BASE_PATH}/delivery-method`,
    GETALL: `${this.API_BASE_PATH}/delivery-method`,
    UPDATE: `${this.API_BASE_PATH}/delivery-method/DELIVERYMETHODID`,
    GETBYID: `${this.API_BASE_PATH}/delivery-method/DELIVERYMETHODID`,
  };

  //BRANCH
  public static BRANCH = {
    CREATE: `${this.API_BASE_PATH}/branch`,
    GETALL: `${this.API_BASE_PATH}/branch`,
    UPDATE: `${this.API_BASE_PATH}/branch/branch-id/BRANCHID`,
    GETBYID: `${this.API_BASE_PATH}/branch/branch-id/BRANCHID`,
    GETBYPARTNERID: `${this.API_BASE_PATH}/branch/partner-id/PARTNERID`,
    IMPORTFROMEXCEL: `${this.API_BASE_PATH}/branch/import-excel`,
  };

  // SYSTEM SETTINGS
  public static SYSTEMSETTINGS = {
    GET: `${this.API_BASE_PATH}/system-settings`,
    UPDATE: `${this.API_BASE_PATH}/system-settings`,
    STAFF_ONBOARDING: `${this.API_BASE_PATH}/system-settings/staff-onboarding`,
  };
}
